// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '../../../hoc/withStyles';
import Spinner from '../../Spinner';
import styles from '../SpinnerOverlay.style';

const SpinnerOverlay = ({
  className,
  spc,
  applePayInProgress,
  isPLCCModalOpen,
  afterPayPaymentProgress,
  isPaypalPaymentProgress,
}) => {
  return (
    <div className={className}>
      <div id="default_spinner_overlay" className="spinner-overlay">
        <Spinner
          spc={spc}
          applePayInProgress={applePayInProgress}
          isPLCCModalOpen={isPLCCModalOpen}
          afterPayPaymentProgress={afterPayPaymentProgress}
          isPaypalPaymentProgress={isPaypalPaymentProgress}
        />
      </div>
    </div>
  );
};

SpinnerOverlay.defaultProps = {
  className: '',
  spc: false,
  applePayInProgress: false,
  isPLCCModalOpen: false,
};

SpinnerOverlay.propTypes = {
  className: PropTypes.string,
  spc: PropTypes.bool,
  applePayInProgress: PropTypes.bool,
  isPLCCModalOpen: PropTypes.bool,
};

export default withStyles(SpinnerOverlay, styles);
export { SpinnerOverlay as SpinnerOverlayVanilla };
